export default function registerConfluence (lf) {
  lf.register('confluence', ({ PolygonNode, PolygonNodeModel, h }) => {
    class Node extends PolygonNode {
      getIconShape () {
        const {model} = this.props
        const {x,y,width, height} = model
        const {stroke} = model.getNodeStyle()
        return h(
          "svg",{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink",x:width/2-25,y:height/2-25,"width":"50","height":"50","viewBox":"0 0 40 40","fill":"none"},
          h("g",{"opacity":"1","transform":"translate(0 0)  rotate(0 20 20)"}),
          h("g",{"mask":"url(#bg-mask-0)"}),
          h("path",{"id":"分组 1","fill-rule":"evenodd","style":"fill:#43CF7C","transform":"translate(3.3331054640751354 3.3333279374132063)  rotate(0 16.66798572246001 16.668723459604454)","opacity":"1","d":"M6.67 33.33C7.59 33.33 8.33 32.59 8.33 31.67L8.33 20.54C11.12 24.51 15.37 27.21 20.15 28.06C20.84 31.34 23.87 33.59 27.21 33.31C30.56 33.04 33.18 30.32 33.33 26.97C33.48 23.62 31.12 20.68 27.82 20.1C24.51 19.52 21.29 21.49 20.3 24.69C14.44 23.48 9.86 18.9 8.64 13.04C11.79 12.06 13.76 8.93 13.27 5.67C12.77 2.41 9.97 0 6.67 0C3.31 0 0.47 2.5 0.05 5.83C-0.37 9.17 1.76 12.29 5.01 13.13C5.01 13.19 5 13.26 5 13.33L5 31.67C5 32.59 5.75 33.33 6.67 33.33Z M23.7836 25.0033C23.1836 26.0333 23.1836 27.3033 23.7836 28.3333C24.3736 29.3633 25.4736 30.0033 26.6636 30.0033C28.5036 30.0033 30.0036 28.5033 30.0036 26.6633C30.0036 24.8233 28.5036 23.3333 26.6636 23.3333C25.4736 23.3333 24.3736 23.9733 23.7836 25.0033Z M3.33356 6.66334C3.33356 8.50334 4.82356 10.0033 6.66356 10.0033C8.50356 10.0033 10.0036 8.50334 10.0036 6.66334C10.0036 4.82334 8.50356 3.33334 6.66356 3.33334C4.82356 3.33334 3.33356 4.82334 3.33356 6.66334Z "}),
          h("mask",{"id":"bg-mask-0","fill":"white"}),
          h("use",{"xlink:href":"#path_0"}),
          h("rect",{"id":"path_0","x":"0","y":"0","width":"40","height":"40"}),

        )
      }
      getShape () {
        const {model} = this.props
        const {width, height, x, y, points} = model
        const {fill, fillOpacity, strokeWidth, stroke, strokeOpacity,} = model.getNodeStyle()
        const transform = `matrix(1 0 0 1 ${x - width / 2} ${y - height / 2})`
        const pointsPath = points.map(point => point.join(',')).join(' ')
        return h(
          'g',
          {
            transform
          },
          [
            h("svg",{"xmlns":"http://www.w3.org/2000/svg","version":"1.1"}),
            h("rect",{"width":width,"height":height,"style":"fill:#ffffff;stroke-width:1;stroke:#aaaaaa;"}),
            this.getIconShape()
          ]
        )
      }
    }
    class Model extends PolygonNodeModel {
      constructor (data, graphModel) {
        data.text = {
          value: (data.text && data.text.value) || '',
          x: data.x,
          y: data.y + 50
        }
        super(data, graphModel)
        // 右键菜单自由配置，也可以通过边的properties或者其他属性条件更换不同菜单
        this.menu = [
          {
            className: 'lf-menu-delete',
            text: '删除',
            callback (node) {
              // const comfirm = window.confirm('你确定要删除吗？')
              lf.deleteNode(node.id)
            }
          },
          {
            text: '修改',
            className: 'lf-menu-item',
            callback (node) {
              lf.editText(node.id)
            }
          },
          {
            text: '复制',
            className: 'lf-menu-item',
            callback (node) {
              lf.cloneNode(node.id)
            }
          }
        ]
      }
      initNodeData(data) {
        super.initNodeData(data)
        const lenght = 35
        this.points = [
          [lenght, 0],
          [lenght * 2, lenght],
          [lenght, lenght * 2],
          [0, lenght]
        ]
      }
      // 自定义锚点样式
      getAnchorStyle() {
        const style = super.getAnchorStyle();
        style.hover.r = 8;
        style.hover.fill = "rgb(24, 125, 255)";
        style.hover.stroke = "rgb(24, 125, 255)";
        return style;
      }
    }
    return {
      view: Node,
      model: Model
    }
  })
}



// WEBPACK FOOTER //
// ./src/components/Admin/Flow/bpmn/registerNode/registerConfluence.js